namespace Matrix.Rebalancer {
    export interface SummaryViewInstanceForm {
        InstanceCode: Serenity.StringEditor;
        ViewCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        Account: SummaryViewAccountGrid;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class SummaryViewInstanceForm extends Serenity.PrefixedContext {
        static formKey = 'Rebalancer.SummaryViewInstance';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!SummaryViewInstanceForm.init)  {
                SummaryViewInstanceForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = SummaryViewAccountGrid;
                var w2 = StaticTextBlock;
                var w3 = ReadOnlyDateTime;

                Q.initFormType(SummaryViewInstanceForm, [
                    'InstanceCode', w0,
                    'ViewCode', w0,
                    'Name', w0,
                    'Account', w1,
                    'CreatedBy', w2,
                    'CreatedWhen', w3,
                    'UpdatedBy', w2,
                    'UpdatedWhen', w3,
                    'Version', w2
                ]);
            }
        }
    }
}
